import React, {Component} from 'react';
import Helmet from 'react-helmet';

const initialState = {
}

class MobilenumberRegistGuide extends Component {
  state=initialState

  // 初期処理
  componentDidMount() {

    // 「GA計測用データレイヤースクリプト追加処理」を呼出す
    window.addDataLayerScript('jmbauth_smsotp_mobile_registration_line');
  }

  // 通知先の登録ボタン押下時処理
  regist = () => {
    window.open(`${process.env.REACT_APP_CONTEXT_PATH}/mobilenumber_change?design=`
       + sessionStorage.getItem('design') + "&lang=" + sessionStorage.getItem('lang') + "&registTransType=REGIST_GUID");
  }

  // 画面表示処理
  render() {

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    return (
      <section className="content">

        {/* ブラウザタイトル */}
        <Helmet
          title={messageList.mobilenumberRegistGuide.M001_browserTitle} >
        </Helmet>

        {/* 画面タイトル表示部 */}
        <div className="ds-heading ds-heading--lg">
          <h1 className="ds-heading__title">{messageList.mobilenumberRegistGuide.M002_pageTitle}</h1>
        </div>

        <div className="contentInner">
          {/* ガイドメッセージ表示部 */}
          <p className="ds-text">{messageList.mobilenumberRegistGuide.M003_guideMessage001}</p>

          {/* 操作ボタン表示部 */}
          <div className="buttonLayout">
            <div className="buttonWrap buttonWrap--center">
              <div className="ds-button ds-button--primary ds-button--large">
                <button className="ds-button__trigger" type="button" onClick={this.regist}>
                  <span className="ds-button__label">{messageList.mobilenumberRegistGuide.M005_regist}</span>
                </button>
              </div>
            </div>
            <div className="buttonWrap buttonWrap--left">
              <div className="ds-button ds-button--tertiary ds-button--large">
                <a className="ds-button__trigger" href="https://www.jal.com/index.html">
                  <span className="ds-button__label">{messageList.mobilenumberRegistGuide.M004_home}</span>
                </a>
              </div>
            </div>
          </div>
        </div>

      </section>
    );
  }
}

export default MobilenumberRegistGuide
